import {
  faArrowUpAZ,
  faBan,
  faBarcodeRead,
  faBell,
  faBox,
  faBriefcase,
  faBrush,
  faBuilding,
  faCalendar,
  faCalendarRange,
  faChartLine,
  faClipboard,
  faClock,
  faCodeSimple,
  faCoins,
  faCreditCard,
  faFileInvoice,
  faFont,
  faGlobe,
  faGlobeAsia,
  faHandHoldingUsd,
  faHome,
  faHospital,
  faImage,
  faInventory,
  faKeySkeletonLeftRight,
  faLayerGroup,
  faLink,
  faMap,
  faMemoPad,
  faNewspaper,
  faNote,
  faOption,
  faPeopleGroup,
  faRobot,
  faRulerHorizontal,
  faScaleBalanced,
  faSign,
  faStore,
  faTableCellsLarge,
  faTag,
  faTimer,
  faTruck,
  faUsdCircle,
  faUsers,
  faWebhook,
} from '@fortawesome/pro-light-svg-icons'

export const systemManagerIcons = {
  activities: faClipboard,
  agencies: faStore,
  'API-keys': faKeySkeletonLeftRight,
  'assigned-publications': faMemoPad,
  'brand-groups': faHospital,
  'brand-themes': faBrush,
  brands: faBuilding,
  bundles: faInventory,
  campaigns: faHome,
  'compatible-products': faHome,
  countries: faGlobeAsia,
  'custom-shortcodes': faCodeSimple,
  'deadline-groups': faCalendar,
  'deep-links': faLink,
  disclaimers: faNote,
  editions: faCalendarRange,
  'editorial-publications': faNewspaper,
  fonts: faFont,
  invoices: faFileInvoice,
  'lead-times': faClock,
  libraries: faImage,
  notifications: faBell,
  options: faOption,
  'order-codes': faArrowUpAZ,
  packages: faBox,
  'pagination-rules': faRulerHorizontal,
  'payment-methods': faCreditCard,
  portals: faGlobe,
  'price-lists': faCoins,
  'pricing-plans': faUsdCircle,
  'processing-fees': faHandHoldingUsd,
  'product-codes': faBarcodeRead,
  products: faHome,
  providers: faTruck,
  publications: faMemoPad,
  'publication-rules': faScaleBalanced,
  reporting: faChartLine,
  roles: faUsers,
  'service-categories': faLayerGroup,
  services: faSign,
  'special-deadlines': faTimer,
  statuses: faBan,
  suburbs: faMap,
  systems: faRobot,
  tags: faTag,
  teams: faPeopleGroup,
  'template-categories': faTableCellsLarge,
  templates: faTableCellsLarge,
  'training-courses': faBriefcase,
  users: faUsers,
  webhooks: faWebhook,
}

/* eslint-disable import/prefer-default-export */

export const dashboardSearchOptions = {
  admin: {
    searchEntitiesById: [
      'Agency',
      'Artwork',
      'ArtworkPage',
      'Campaign',
      'CampaignProposal',
      'DigitalPage',
      'Order',
      'OrderItem',
      'Provider',
      'TemplatePage',
      'User',
    ],
    searchEntitiesByDetail: [
      'Agency',
      'Campaign',
      'Provider',
      'User',
    ],
  },
  agency: {
    searchEntitiesById: [
      'Artwork',
      'Campaign',
      'CampaignQuote',
      'CampaignQuoteTemplate',
      'Invoice',
      'Order',
    ],
    searchEntitiesByDetail: [
      'Campaign',
      'CampaignQuoteTemplate',
      'User',
    ],
  },
  brand: {
    searchEntitiesById: [
      'Agency',
      'Campaign',
      'Order',
    ],
    searchEntitiesByDetail: [
      'Agency',
      'Campaign',
      'Order',
    ],
  },
  provider: {
    searchEntitiesById: [
      'Agency',
      'Campaign',
      'Order',
    ],
    searchEntitiesByDetail: [
      'Agency',
      'Campaign',
    ],
  },
}
